import React, { useEffect } from "react";
import { motion, useCycle } from "framer-motion";
import HeaderNav from "./SideNav/HeaderNav";
import ListNav from "./SideNav/ListNav";
import { ReactComponent as Assistenza } from "../assets/new-icons/assistenza.svg";
import { ReactComponent as Close } from "../assets/new-icons/close.svg";
import { ReactComponent as Notifica } from "../assets/new-icons/notifica.svg";
import Assistence from "./SideNav/Assistence";
import { useNavigate } from "react-router";
import { useLocation } from "react-router-dom";
import { ReactComponent as Logo } from "../assets/img/logo-esteso.svg";
import { ReactComponent as LogoW } from "../assets/img/logo_esteso_wh.svg";
import { ReactComponent as Menu } from "../assets/new-icons/menu.svg";
import { useSelector } from "react-redux";
import Notification from "./New Header/Notification/Notification";
import { Badge } from "@mui/material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const sidebar = {
  open: (height = 1000) => ({
    clipPath: `circle(${height * 2 + 200}% at 84% 5%)`,
    transition: {
      type: "spring",
      stiffness: 20,
      restDelta: 2,
      damping: 40,
    },
  }),
  closed: {
    clipPath: "circle(0px at 84% 5%)",
    transition: {
      delay: 0.4,
      type: "spring",
      stiffness: 400,
      damping: 40,
    },
  },
};

function Header({overlay, title, setOverlay, color = '#697386', navigation, setNavigation}) {
  
  const navigate = useNavigate();
  const location = useLocation();
  const [isOpen, toggleOpen] = useCycle(false, true);
  const [menuOpen, toggleMenu] = useCycle(false, true);
  const [notificationOpen, toggleNotification] = useCycle(false, true);
  const [assistenceOpen, toggleAssistence] = useCycle(false, true);
  const section = useSelector((user) => user.settings.section);
  const selectorUser = useSelector((user) => user.user);
  const notifiche = selectorUser.notifiche;
  const allNotifiche = notifiche && [...notifiche[0], ...notifiche[1]];

  const handleMenu = () => {
    console.log('first')
    toggleMenu();
    toggleOpen();
  };
  const handleNotification = () => {
    toggleOpen();
    toggleNotification();
  };
  const handleAssistence = () => {
    toggleOpen();
    toggleAssistence();
  };
  useEffect(() => {
    document.body.style.overflow = menuOpen || assistenceOpen || notificationOpen ? "hidden" : null;
    document.body.style.touchAction = menuOpen || assistenceOpen || notificationOpen ? "none" : null;
  }, [menuOpen, assistenceOpen, notificationOpen]);

  const handleSet = () => {
    setNavigation(!navigation)
    setOverlay(!overlay)
  }
  return (
    <>
      
      <div className={`mainHeader ${
        location.pathname === '/enrica/movimenti' ? 'gradient' : null
      }`}>
        {overlay || navigation ? (
          <div className="title" style={{color: color, fill: color}} onClick={() => navigation ? navigate(-1) :  handleSet()}>
            <ArrowBackIcon />
            <p className="main">
              {title}
            </p>
          </div>
        ) : (

          <div className="logo">
            {menuOpen || assistenceOpen ? null : location.pathname === '/enrica/movimenti' ? <LogoW/> : <Logo />}
          </div>
        )}
        <button
          disabled={menuOpen || notificationOpen}
          className={`assistence ${assistenceOpen}`}
          onClick={() => handleAssistence()}
          style={menuOpen || notificationOpen ? { display: "none" } : null}
        >
          {assistenceOpen ? (
            <Close />
          ) : (
            <Assistenza className={menuOpen || navigation || overlay ? "white" : "gray"} />
          )}
        </button>
        {assistenceOpen ? null : (
          <>
            {!section && (
              <button
                disabled={menuOpen || assistenceOpen}
                className={`notification ${notificationOpen}`}
                onClick={() => handleNotification()}
                style={
                  menuOpen || assistenceOpen ? { display: "none" } : null
                }
              >
                {notificationOpen ? (
                  <Close />
                ) : (
                  notifiche[0].length > 0 ? (
                    <Badge color="secondary" style={{width: '20px', height: '20px'}} badgeContent={notifiche[0].length}>
                      <Notifica className={menuOpen || navigation || overlay ? "white" : "gray"} />
                    </Badge>
                  ) : notifiche[1].length > 0 ? (
                    <Badge color="secondary"  style={{width: '20px', height: '20px'}} badgeContent={notifiche[1].length}>
                      <Notifica className={menuOpen || navigation || overlay ? "white" : "gray"} />
                    </Badge>
                  ) : (
                      <Notifica className={menuOpen || navigation || overlay ? "white" : "gray"} />
                  )
                )}
              </button>
            )}

            <button
              disabled={notificationOpen || assistenceOpen}
              className={`menu ${menuOpen}`}
              onClick={() => handleMenu()}
            >
              {menuOpen ? <Close /> : <Menu style={navigation || overlay ? {fill: '#fff'} : null}/>}
            </button>
          </>
        )}
      </div>
     

      <motion.div initial={false} animate={isOpen ? "open" : "closed"}>
        {(menuOpen && (
          <motion.div
            className={section ? "sidebar orange" : "sidebar"}
            variants={sidebar}
          >
            <HeaderNav opened={menuOpen} handleMenu={() => handleMenu()} />
            <ListNav toggle={() => handleMenu()} />
          </motion.div>
        )) ||
          (notificationOpen && (
            <motion.div
              className="sidebar notification"
              style={notificationOpen ? { overflow: "scroll" } : null}
              variants={sidebar}
            >
              <Notification handleNotification={handleNotification} />
            </motion.div>
          )) ||
          (assistenceOpen && (
            <motion.div
              className="sidebar assistence"
              style={assistenceOpen ? { overflow: "scroll" } : null}
              variants={sidebar}
            >
              <Assistence />
            </motion.div>
          ))}
      </motion.div>
    </>
  );
}

export default Header;

const MenuToggle = (props) => (
  <button className={`menu ${props.class}`} onClick={props.toggle}>
    {props.menuOpen ? "A" : "B"}
  </button>
);
